import { render, staticRenderFns } from "./ThresholdSelect.vue?vue&type=template&id=5393cbe1&scoped=true"
import script from "./ThresholdSelect.vue?vue&type=script&lang=js"
export * from "./ThresholdSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393cbe1",
  null
  
)

export default component.exports